import { serviceAgreementApi } from 'api';

export const getDocumentFromApi = async (serviceAgreementId: string, documentUid: string) => {
  return await serviceAgreementApi.getPcdDocumentIdById({
    serviceAgreementUid: serviceAgreementId,
    documentId: documentUid,
  });
};
